import { render, staticRenderFns } from "./home-notifications.vue?vue&type=template&id=2b0df3a6&"
import script from "./home-notifications.vue?vue&type=script&lang=js&"
export * from "./home-notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports